<p-dialog
    [(visible)]="isModalDisplayed"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '80vw', maxWidth: '900px' }"
    [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
    appendTo="body"
    (onHide)="handleOnCancel()"
    [closable]="false"
    styleClass="custom-comment-edit-modal"
>
    <p-header>
        <span class="d-none d-md-flex">{{ title }}</span>
        <div class="d-flex d-md-none justify-content-between">
            <div class="d-flex">
                <button pButton pRipple type="button" icon="pi pi-times" class="p-button-secondary p-button-text" (click)="handleOnCancel()"></button>
            </div>
            <div class="d-flex">
                <ng-container *ngTemplateOutlet="buttons"> </ng-container>
            </div>
        </div>
        <p-divider class="d-flex d-md-none"></p-divider>
    </p-header>

    <div class="p-d-flex p-flex-column p-px-2 p-mt-2" style="max-width: 1033px">
        <form>
            <div class="user-information-frame">
                <p-avatar
                    [image]="currentUser.pictureReference"
                    styleClass="comment-profile-picture avatar"
                    size="large"
                    shape="circle"
                    [style]="{ 'background-color': 'var(--gray-light)' }"
                    [label]="!currentUser.pictureReference ? currentUser.firstName.slice(0, 1) + currentUser.lastName.slice(0, 1) : ''"
                ></p-avatar>
                <div class="publication-information ps-2">
                    <div class="d-flex align-items-center">
                        <div>
                            <div class="fw-bold">{{ currentUser.firstName }} {{ currentUser.lastName }}</div>
                            <div class="text-muted">{{ currentClubTitle }} ▸ {{ currentRoomTitle }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="input-information-frame">
                <div class="length-information">{{ contentLength }}/{{ PUBLICATION_CONTENT_MAX_LENGTH }}</div>
            </div>
            <div class="publication-frame">
                <quill-editor
                    #newPublicationQuillEditor
                    id="content"
                    [formControl]="form.controls.content"
                    placeholder="{{ 'clubs.page.tabs.discussion.post.comment.commentPlaceholder' | translate }}"
                    theme="snow"
                    required="true"
                    [modules]="publicationQuillEditorHelper.noToolbar"
                    [formats]="quillEditorHelper.formats"
                    (paste)="handlePaste($event)"
                    [mention]="members"
                    [mentionConfig]="{ dropUp: false }"
                    (mentionSelectedEvent)="onMentionSelected($event)"
                    (keydown)="onKeydown($event)"
                    (opened)="onMentionListOpen()"
                    (closed)="onMentionListClosed()"
                    (dragover)="(false)"
                >
                </quill-editor>

                <div class="row">
                    <div class="col">
                        <div class="buttons" style="display: flex; justify-content: flex-end">
                            <button
                                #emojiButton
                                class="picker-button"
                                title="{{ 'clubs.page.tabs.discussion.post.emoji' | translate }}"
                                (click)="handleEmojiPickerButtonClick()"
                            >
                                <i class="icon-o-smile custom-icon"></i>
                            </button>
                            <label for="file"></label>
                            <input
                                [formControl]="form.controls.image"
                                #imageInput
                                type="file"
                                accept="image/*"
                                style="display: none"
                                (change)="updateImage($event)"
                            />
                            <button
                                *ngIf="!localImageSrc"
                                class="picker-button"
                                (click)="imageInput.click()"
                                title="{{ 'clubs.page.tabs.discussion.post.image' | translate }}"
                            >
                                <i class="icon-picture custom-icon"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="emoji-container comment-emoji-container-transform">
                    <emoji-mart
                        #emojiPicker
                        *ngIf="isEmojiPickerVisible"
                        class="emoji-picker-container"
                        title="{{ 'clubs.page.tabs.discussion.post.selectEmoji' | translate }}"
                        [darkMode]="false"
                        [i18n]="emojiTranslations"
                        [skin]="2"
                        [isNative]="true"
                        color="var(--primary-background)"
                        [hideObsolete]="false"
                        [showPreview]="false"
                        [showSingleCategory]="true"
                        (emojiSelect)="addEmojiToContent($event)"
                    ></emoji-mart>
                </div>

                <div *ngIf="localImageSrc || cropperParams?.urlImage" class="image-container">
                    <image-cropper-old
                        *ngIf="localImageSrc || cropperParams?.urlImage"
                        style="width: auto"
                        [format]="'png'"
                        [imageChangedEvent]="imageService.imageChangedEvent"
                        [imageBase64]="localImageSrc"
                        [imageURL]="cropperParams.urlImage"
                        [maintainAspectRatio]="cropperParams.isRatioFix"
                        [containWithinAspectRatio]="imageService.containWithinAspectRatio"
                        [aspectRatio]="cropperParams.ratio"
                        [cropperMinWidth]="cropperParams.minWidth"
                        [cropperMinHeight]="cropperParams.minHeight"
                        [onlyScaleDown]="true"
                        [roundCropper]="false"
                        [canvasRotation]="imageService.canvasRotation"
                        [alignImage]="cropperParams.alignImage"
                        [style.display]="null"
                        [resizeToWidth]="cropperParams.resizeToWidth"
                        [resizeToHeight]="cropperParams.resizeToHeight"
                        (imageCropped)="imageHasBeenCropped($event)"
                        (imageLoaded)="imageService.imageLoaded()"
                        (loadImageFailed)="imageService.loadImageFailed()"
                    ></image-cropper-old>
                    <button
                        *ngIf="localImageSrc || cropperParams?.urlImage"
                        pButton
                        pRipple
                        type="button"
                        icon="pi pi-times"
                        class="p-button-rounded p-button-danger remove-button"
                        (click)="handleRemoveImage()"
                    ></button>
                </div>
            </div>
            <div *ngIf="form.controls.content.invalid && (form.controls.content.dirty || form.controls.content.touched)">
                <div class="danger-text p-mx-2" *ngIf="contentLength > PUBLICATION_CONTENT_MAX_LENGTH">
                    {{
                        'clubs.page.tabs.discussion.post.textLengthValidator'
                            | translate : { publicationContentMaxLength: PUBLICATION_CONTENT_MAX_LENGTH, currentTextLength: contentLength }
                    }}
                </div>
            </div>
        </form>
    </div>

    <p-footer *ngIf="!isMobile">
        <button
            pButton
            pRipple
            type="button"
            class="p-button-text p-button"
            label="{{ 'components.button.buttonCancel' | translate }}"
            (click)="handleOnCancel()"
        ></button>
        <ng-container *ngTemplateOutlet="buttons"> </ng-container>
    </p-footer>
</p-dialog>

<ng-template #buttons>
    <ng-container>
        <button
            pButton
            pRipple
            class="p-button"
            type="button"
            [label]="action"
            (click)="handleOnSubmit()"
            [disabled]="!form.valid || submitted"
        ></button>
    </ng-container>
</ng-template>
